import type { BadgeVariant } from '../../components/ui';
import type { KhoaDich } from '../../i18n';
import { MA_CO_NHAN } from './nghiep-vu/danh-muc-hanh-dong';
import type { NguonGhi, TrangThaiLuuTru, TrangThaiXoa } from './types';

/**
 * Mã thao tác đã biết của `audit_log.action` → khoá dịch, dựng từ danh mục
 * (`nghiep-vu/danh-muc-hanh-dong.ts`). Phương thức HTTP không có ở đây: chúng
 * dùng chung nhãn `nhatKy.goiApi` có tham số.
 *
 * Mã lạ (phiên bản mới thêm thao tác mà giao diện chưa biết) hiện nguyên văn
 * kèm câu "chưa có trong danh mục" — không đoán nghĩa.
 */
export const HANH_DONG: Readonly<Record<string, KhoaDich>> = Object.fromEntries(
  MA_CO_NHAN.map((ma) => [ma, `nhatKy.hanhDong.${ma}` as KhoaDich]),
);

export const NGUON_GHI: Record<NguonGhi, KhoaDich> = {
  GATEWAY: 'nhatKy.nguon.GATEWAY',
  SERVICE: 'nhatKy.nguon.SERVICE',
  SDK: 'nhatKy.nguon.SDK',
  KEYCLOAK: 'nhatKy.nguon.KEYCLOAK',
};

/**
 * Tông của bước lưu trữ lạnh. Chỉ nhóm biến thể **trạng thái** của `Badge`:
 * `DETACHED` (xong, đã rời bảng nóng) và `DROPPED` (xong hẳn) là `success`,
 * `UPLOADED` đang chờ tách là `primary`, đang chạy là `warning`, lỗi `danger`.
 */
export const TONG_LUU_TRU: Record<TrangThaiLuuTru, BadgeVariant> = {
  PENDING: 'neutral',
  EXPORTING: 'warning',
  UPLOADED: 'primary',
  DETACHED: 'success',
  DROPPED: 'success',
  FAILED: 'danger',
};

/** Bước đã có tệp trên object storage, tải về được. */
export const TAI_DUOC: ReadonlySet<TrangThaiLuuTru> = new Set(['UPLOADED', 'DETACHED', 'DROPPED']);

/**
 * Tông của một lần xoá nhật ký (ADR-0089). Nhóm biến thể **trạng thái**:
 * đang trong thùng rác là việc còn treo, cần để ý (`warning`); đã khôi phục là
 * xong, không còn gì xảy ra (`neutral`); đã xoá vĩnh viễn là mất hẳn, không
 * hoàn tác được (`danger`).
 */
export const TONG_XOA: Record<TrangThaiXoa, BadgeVariant> = {
  ACTIVE: 'warning',
  RESTORED: 'neutral',
  PURGED: 'danger',
};
